import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What job roles can I get after learning C, C++ with DSA?",
    category: "Technology",
    description:
      "You can pursue roles like Software Engineer, C++ Developer, Systems Programmer, Game Developer, Backend Developer, Embedded Engineer, or Performance Engineer. Strong DSA skills enhance opportunities in top tech companies.",
  },
  {
    title: "How does DSA help in real-life applications?",
    category: "Trending",
    description:
      "DSA improves efficiency in search engines, navigation, networks, databases, and applications requiring fast computations. It ensures software handles data optimally and performs well under load.",
  },
  {
    title: "Do I need DSA for placements?",
    category: "Design",
    description:
      "Yes. Most companies test problem-solving and DSA skills in coding rounds. Knowledge of arrays, linked lists, trees, graphs, sorting, and searching is essential for cracking interviews.",
  },
  {
    title: "What is the difference between C and C++?",
    category: "Design",
    description:
      "C is a procedural language focusing on functions, while C++ supports Object-Oriented Programming with classes and objects. C++ offers abstraction, encapsulation, and STL, making development easier and more modular.",
  },
  {
    title: "How does DSA help in real-life applications?",
    category: "Design",
    description:
      "DSA improves efficiency in search engines, navigation, networks, databases, and applications requiring fast computations. It ensures software handles data optimally and performs well under load.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
